import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { APP_BAR_HEIGHT } from '../appBar/DataViewerAppBar'

export const Page = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${APP_BAR_HEIGHT})`,
    [theme.breakpoints.down('sm')]: {
        height: 'unset',
        minHeight: `calc(100vh - ${APP_BAR_HEIGHT})`,
    },
    width: '100%',
    '& .Mui-error': {
        backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
        color: theme.palette.error.main,
    },
}))
